module.exports = __webpack_public_path__ + "static/media/lp-3.a88d739a.png";